import { Component,OnInit,OnDestroy,AfterViewInit,ElementRef,ViewChild } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable,Subject,BehaviorSubject } from "rxjs";
import { takeWhile } from "rxjs/operators";
import { format,parse,differenceInSeconds } from 'date-fns';
import addDays from 'date-fns/addDays';
import { DatePipe } from '@angular/common';

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsExcelService
    ,FvmsApiDtgReportRestService
    ,FvmsDtgDriveScheduleRestService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
    ,dtgCarTypeList
    ,DtgDriveScheduleRow
    ,DtgDriveScheduleItem
    ,DtgDriveScheduleItemDrive
    ,DtgDriveScheduleItemRest
    ,DriveScheduleRow
    ,DriveScheduleItem
} from "src/app/shared/vo";
import {
    FilterDist
    ,FilterSecToTime
    ,FilterDateTime
} from "src/app/shared/filter";

import {
    DtgManageCompanySearchComponent
} from "src/app/dtg/manage/company/search/dtg.manage.company.search.component";

@Component({
    templateUrl: './dtg.test.t03.component.html'
    ,styleUrls: []
    ,providers: []
})
export class DtgTestT03Component implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    DtgActionType=DtgActionType;
    listDevice:any[] = [];
    selectedVideo:any;
    selectedAudio:any;
    @ViewChild('video01') video01:ElementRef;
    streamSession:any;

    constructor(
        private modalService: NgbModal
    ) {
        
    }

    ngOnInit() {
        // this.initDevice();
        // this.loadListDevice();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        this.loadListDevice();
    }

    clickOpenModalCompanyInfo(dtgActionType:DtgActionType){
        let modalRef = this.modalService.open(
            DtgManageCompanySearchComponent
            ,{
                centered:true
                ,size: "lg"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.dtgActionType = dtgActionType;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        console.log("result",resultModal.result);
                    }
                    break;
                default:
                    break;
            }
        });
    }

    async loadListDevice(){
        this.listDevice = await navigator.mediaDevices.enumerateDevices();
        console.log("listDevice",this.listDevice);
    }

    getListDeviceByType(deviceType:any){
        if(this.listDevice){
            return this.listDevice.filter(device => device.kind === deviceType);
        }
        return null;
    }

    playVideo(){
        // let mediaOpt = {video:true,audio:false};
        // var mediaOpt = {
        //     audio: {deviceId: this.selectedAudio?.deviceId ? {exact: this.selectedAudio?.deviceId} : undefined}
        //     ,video: {deviceId: this.selectedVideo.deviceId ? {exact: this.selectedVideo.deviceId} : undefined}
        // };
        var mediaOpt = {
            video: {
                deviceId: this.selectedVideo.deviceId ? {exact: this.selectedVideo.deviceId} : undefined
                ,facingMode:"user" || "environment"
                ,width:{ideal:1280}
                ,height:{ideal:720}
                ,frameRate:{ideal:10,max:15}
            }
            // ,audio: {deviceId: this.selectedAudio?.deviceId ? {exact: this.selectedAudio?.deviceId} : undefined}
            ,audio:true
        };
        navigator.mediaDevices.getUserMedia(mediaOpt).then(
            mediaStream => {
                // console.log("track",mediaStream.getTracks());
                if(!this.streamSession){
                    this.streamSession = mediaStream.getTracks();
                }else{
                    this.streamSession.forEach(track => {
                        track.stop();
                    });
                }
                let video01El = this.video01.nativeElement;
                if('srcObject' in video01El) {
                    video01El.srcObject = mediaStream;
                }else{
                    video01El.src = URL.createObjectURL(mediaStream);
                }

                video01El.onloadedmetadata = function(e){
                    video01El.play();
                }
            }
            ,err => {
                console.error("err",err);
            }
        );
    }

    stopVideo(){
        if(this.streamSession){
            this.streamSession.forEach(track => {
                track.stop();
            });
        }
        let video01El = this.video01.nativeElement;
        video01El.stop();
    }
}